import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";
import Signup from "./components/signup/signup";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import ResetPass from "./components/ResetPassword/ResetPass";
import Login from "./components/Login/Login";
import DashBoard from "./components/DashBoard/DashBoard";

function App() {
  return (
    <Router>
      <div className="app">
        <Switch>
          <Route path="/" exact>
            <Login />
          </Route>
          <Route path="/sign-up" exact>
            <Signup />
          </Route>
          <Route path="/forgotPass" exact>
            <ForgotPassword />
          </Route>
          <Route path="/resetPass" exact>
            <ResetPass />
          </Route>
          <Route path="/DashBoard" exact>
            <DashBoard />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
